import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { RevealSection } from './shared';
import i18n from 'i18next';

export const FaqSection = ({ sid, theme, faqs, txt }) => (
  <section id={sid} className="py-20" style={{ background: 'linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%)' }} data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <RevealSection className="text-center mb-16">
        <div className="inline-block mb-4 px-4 py-1.5 rounded-full text-sm font-medium" style={{ backgroundColor: `${theme.primary_color}15`, color: theme.primary_color }}>{txt('faq', 'badge')}</div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4" style={{ fontFamily: `${theme.font_heading}, sans-serif` }}>{txt('faq', 'title')}</h2>
        <p className="text-base md:text-lg text-slate-500" style={{ fontFamily: `${theme.font_body}, sans-serif` }}>{txt('faq', 'subtitle')}</p>
      </RevealSection>
      <RevealSection>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, index) => {
            const lang = i18n.language;
            const question = (lang === 'en' && faq.question_en) ? faq.question_en : (faq.question_cs || faq.question);
            const answer = (lang === 'en' && faq.answer_en) ? faq.answer_en : (faq.answer_cs || faq.answer);
            return (
              <AccordionItem key={faq.id} value={faq.id} className="border-2 border-green-100 rounded-2xl px-6 bg-white hover:border-green-300 hover:shadow-lg shadow-sm transition-all duration-400" data-testid={`faq-item-${index}`}>
                <AccordionTrigger className="text-base md:text-lg font-semibold text-slate-800 hover:text-green-700 py-5" style={{ fontFamily: `${theme.font_heading}, sans-serif` }}>{question}</AccordionTrigger>
                <AccordionContent className="text-slate-500 pb-5 leading-relaxed" style={{ fontFamily: `${theme.font_body}, sans-serif` }}>{answer}</AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </RevealSection>
    </div>
  </section>
);
